import React from 'react';
import './js/binsentry-app';
import './lit-imports';

export default function BinSentryUI ({ href, authConfig }) {
  return <binsentry-app
    href={href}
    authConfig={JSON.stringify(authConfig)}
  />;
}
